<template>
  <VueApexCharts
    type="bar"
    height="500"
    :options="chartOptions"
    :series="chartSeries"
  />
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'OperationsChart',
  props: {
    metrics: {
      type: Array,
      required: true
    }
  },
  components: {
    VueApexCharts
  },
  computed: {
    sortedMetrics () {
      // sort descending by total FDA (on-time + overdue)
      return [...this.metrics].sort((a, b) => {
        const totalA = (a.open_fda || 0)
        const totalB = (b.open_fda || 0)
        return totalB - totalA
      })
    },
    chartSeries () {
      return [
        {
          name: 'Jobs On-Time',
          group: 'Jobs',
          data: this.sortedMetrics.map(m => (m.open_fda || 0) - (m.ops_overdue_fda || 0))
        },
        {
          name: 'Jobs Overdue',
          group: 'Jobs',
          data: this.sortedMetrics.map(m => m.ops_overdue_fda || 0)
        },
        {
          name: 'PDA On-Time',
          group: 'PDA',
          data: this.sortedMetrics.map(m => (m.open_pda || 0) - (m.overdue_pda || 0))
        },
        {
          name: 'PDA Overdue',
          group: 'PDA',
          data: this.sortedMetrics.map(m => m.overdue_pda || 0)
        }
      ]
    },
    chartOptions () {
      return {
        chart: {
          type: 'bar',
          stacked: true,
          height: this.sortedMetrics.length * 55
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '80%',
            dataLabels: {
              position: 'center' // show individual values inside bar
            }
          }
        },
        dataLabels: {
          enabled: true
        },
        colors: [
          '#059669', // FDA On-Time
          '#F87171', // FDA Overdue
          '#1E3A8A', // PDA On-Time
          '#DC2626'  // PDA Overdue
        ],
        xaxis: {
          categories: this.sortedMetrics.map(m => m.supervisor_name || 'Unassigned')
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left'
        }
      }
    }
  }
}
</script>
